import React from 'react'
import { Container } from 'reactstrap'
import { connect } from 'react-redux'

import { Alert } from '../../../components/reactstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'

import AlertMessage from '../../../components/AlertMessage'
import projectExportsActions from '../ProjectExports/actions'

const ProjectExportBanner = ({
  dispatch,
  checkingError = null,
  checkingStatus = 'idle',
  hasAny = false,
  project = null,
  projectExports = null,
  projectExportsFetchingError = null,
  projectExportsFetchingStatus = 'idle'
}) => {
  const { t } = useTranslation(['ProjectsPage', 'commons'])

  if (checkingStatus === 'idle') {
    dispatch(projectExportsActions.checkIfAny(project.id))
  }

  if (projectExportsFetchingStatus === 'idle') {
    dispatch(projectExportsActions.fetchAll(project.id))
  }

  let existingProjectExport

  if (projectExportsFetchingStatus === 'succeeded') {
    existingProjectExport = (projectExports || []).find(
      (item) => ['pending', 'exporting'].includes(item.state)
    )
  }

  if (checkingStatus === 'failed'
      || projectExportsFetchingStatus === 'failed') {
    return (
      <Container className="mt-2">
        {checkingStatus === 'failed' && (
          <AlertMessage>
            {typeof checkingError === 'string'
              ? checkingError
              : t('errors.somethingWentWrong', { ns: 'commons' })}
          </AlertMessage>
        )}

        {projectExportsFetchingStatus === 'failed' && (
          <AlertMessage>
            {projectExportsFetchingError || t('errors.somethingWentWrong', { ns: 'commons' })}
          </AlertMessage>
        )}
      </Container>
    )
  }

  if (checkingStatus === 'succeeded'
      && projectExportsFetchingStatus === 'succeeded'
      && hasAny
      && [null, undefined].includes(existingProjectExport)
  ) {
    return (
      <Alert className="border-0" color="warning">
        <div className="d-flex flex-row justify-content-between">
          <div className="d-flex flex-column justify-content-center">
            <span>{t('ProjectPage.ProjectExportBanner.text')}</span>
          </div>
          <Link
            className="btn btn-warning text-decoration-none px-5"
            to={`/projects/${project.id}/exports/new`}
          >
            {t('ProjectPage.ProjectExportBanner.buttons.checkDiff')}
          </Link>
        </div>
      </Alert>
    )
  }

  return null
}

ProjectExportBanner.propTypes = {
  checkingError: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  checkingStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  hasAny: PropTypes.bool,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  projectExports: PropTypes.arrayOf(PropTypes.shape({
    state: PropTypes.string.isRequired
  })),
  projectExportsFetchingError: PropTypes.string,
  projectExportsFetchingStatus: PropTypes.string
}

const mapStateToProps = ({
  projectExports: {
    checkingError,
    checkingStatus,
    fetchingAllError: projectExportsFetchingError,
    fetchingAllStatus: projectExportsFetchingStatus,
    hasAny,
    items: projectExports
  }
}) => ({
  checkingError,
  checkingStatus,
  hasAny,
  projectExports,
  projectExportsFetchingError,
  projectExportsFetchingStatus
})

export default connect(mapStateToProps)(ProjectExportBanner)
